import { overrideToRaces } from "./seasonOverrides";

const decades = [
  { key: "1950s", label: "1950s", from: 1950, to: 1959 },
  { key: "1960s", label: "1960s", from: 1960, to: 1969 },
  { key: "1970s", label: "1970s", from: 1970, to: 1979 },
  { key: "1980s", label: "1980s", from: 1980, to: 1989 },
  { key: "1990s", label: "1990s", from: 1990, to: 1999 },
  { key: "2000s", label: "2000s", from: 2000, to: 2009 },
  { key: "2010s", label: "2010s", from: 2010, to: 2019 },
  { key: "2020s", label: "2020s", from: 2020, to: 2026 },
];

const entity = (name, rating, firstYear, lastYear, decade) => ({
  id: `${name}-${decade}`.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
  name,
  rating,
  firstYear,
  lastYear,
  seasons: Math.max(1, lastYear - firstYear + 1),
  decade,
});

const group = (rows) =>
  rows.reduce((acc, row) => {
    const item = entity(row[0], row[1], row[2], row[3], row[4]);
    acc[row[4]] = [...(acc[row[4]] || []), item];
    return acc;
  }, {});

export const fallbackBootstrap = {
  currentYear: 2026,
  dataCoverageYear: 2026,
  decades,
  teamsByDecade: group([
    ["Alfa Romeo", 85, 1950, 1951, "1950s"],
    ["Ferrari", 97, 1950, 2026, "1950s"],
    ["Maserati", 78, 1950, 1960, "1950s"],
    ["Vanwall", 76, 1954, 1960, "1950s"],
    ["Cooper", 81, 1950, 1969, "1960s"],
    ["Lotus", 92, 1958, 1994, "1960s"],
    ["Brabham", 88, 1962, 1992, "1960s"],
    ["BRM", 80, 1951, 1977, "1960s"],
    ["Tyrrell", 82, 1970, 1998, "1970s"],
    ["McLaren", 97, 1966, 2026, "1970s"],
    ["Williams", 92, 1977, 2026, "1970s"],
    ["Ligier", 76, 1976, 1996, "1970s"],
    ["Renault", 88, 1977, 2026, "1980s"],
    ["Benetton", 84, 1986, 2001, "1980s"],
    ["Arrows", 70, 1978, 2002, "1980s"],
    ["Minardi", 65, 1985, 2005, "1980s"],
    ["Jordan", 78, 1991, 2005, "1990s"],
    ["Sauber", 76, 1993, 2024, "1990s"],
    ["Stewart", 72, 1997, 1999, "1990s"],
    ["BAR", 72, 1999, 2005, "1990s"],
    ["Red Bull", 96, 2005, 2026, "2000s"],
    ["Mercedes", 98, 1954, 2026, "2000s"],
    ["BMW Sauber", 78, 2006, 2009, "2000s"],
    ["Toyota", 73, 2002, 2009, "2000s"],
    ["Brawn", 86, 2009, 2009, "2000s"],
    ["Force India", 74, 2008, 2018, "2010s"],
    ["Toro Rosso", 71, 2006, 2019, "2010s"],
    ["Haas F1 Team", 70, 2016, 2026, "2010s"],
    ["Racing Point", 73, 2019, 2020, "2010s"],
    ["Alpine", 76, 2021, 2026, "2020s"],
    ["Aston Martin", 78, 2021, 2026, "2020s"],
    ["Racing Bulls", 72, 2024, 2026, "2020s"],
    ["Audi", 74, 2026, 2026, "2020s"],
    ["Cadillac", 72, 2026, 2026, "2020s"],
  ]),
  driversByDecade: group([
    ["Juan Manuel Fangio", 98, 1950, 1958, "1950s"],
    ["Alberto Ascari", 93, 1950, 1955, "1950s"],
    ["Stirling Moss", 92, 1951, 1961, "1950s"],
    ["Nino Farina", 88, 1950, 1955, "1950s"],
    ["Jack Brabham", 92, 1955, 1970, "1960s"],
    ["Jim Clark", 96, 1960, 1968, "1960s"],
    ["Graham Hill", 90, 1958, 1975, "1960s"],
    ["Jackie Stewart", 95, 1965, 1973, "1960s"],
    ["Emerson Fittipaldi", 91, 1970, 1980, "1970s"],
    ["Niki Lauda", 96, 1971, 1985, "1970s"],
    ["James Hunt", 86, 1973, 1979, "1970s"],
    ["Mario Andretti", 91, 1968, 1982, "1970s"],
    ["Nelson Piquet", 94, 1978, 1991, "1980s"],
    ["Alain Prost", 98, 1980, 1993, "1980s"],
    ["Ayrton Senna", 99, 1984, 1994, "1980s"],
    ["Nigel Mansell", 93, 1980, 1995, "1980s"],
    ["Michael Schumacher", 99, 1991, 2012, "1990s"],
    ["Mika Hakkinen", 93, 1991, 2001, "1990s"],
    ["Damon Hill", 89, 1992, 1999, "1990s"],
    ["Jacques Villeneuve", 88, 1996, 2006, "1990s"],
    ["Fernando Alonso", 96, 2001, 2026, "2000s"],
    ["Kimi Raikkonen", 93, 2001, 2021, "2000s"],
    ["Lewis Hamilton", 99, 2007, 2026, "2000s"],
    ["Jenson Button", 89, 2000, 2017, "2000s"],
    ["Sebastian Vettel", 97, 2007, 2022, "2010s"],
    ["Nico Rosberg", 91, 2006, 2016, "2010s"],
    ["Daniel Ricciardo", 87, 2011, 2024, "2010s"],
    ["Valtteri Bottas", 86, 2013, 2026, "2010s"],
    ["Max Verstappen", 99, 2015, 2026, "2020s"],
    ["Charles Leclerc", 92, 2018, 2026, "2020s"],
    ["Lando Norris", 91, 2019, 2026, "2020s"],
    ["Oscar Piastri", 90, 2023, 2026, "2020s"],
    ["George Russell", 90, 2019, 2026, "2020s"],
    ["Kimi Antonelli", 84, 2026, 2026, "2020s"],
    ["Carlos Sainz", 88, 2015, 2026, "2020s"],
    ["Sergio Perez", 88, 2011, 2026, "2020s"],
  ]),
  racesByYear: {
    2025: overrideToRaces(2025),
    2026: overrideToRaces(2026),
  },
};
